app.controller("AddStudentController", ["$scope", "$http", "$uibModalInstance", "Users", "Students", "StaticData", "ProgramService", "toastr",
    function ($scope, $http, $uibModalInstance, Users, Students, StaticData, ProgramService, toastr) {
        $scope.format = "dd-MM-yyyy";
        $scope.choiceNumbers = ["მერამდენე არჩევანია"].concat(_.range(1, 15));
        $scope.choiceNumber = "მერამდენე არჩევანია";
        $scope.semesters = ["სემესტრი"].concat(_.range(1, 15));
        $scope.semester = "სემესტრი";
        $scope.showSubjectField = false;
        $scope.student = {};

        $scope.popup1 = {
            opened: false
        };

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs
            });
        };

        $scope.getUsers = function (name) {
            if (name.length < 1) {
                return [];
            }
            return Users.list({
                query: name
            }).then(function (data) {
                return data.docs
            });
        };

        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = [{name: "სტატუსი"}].concat(states);
            $scope.statesMap = _.keyBy($scope.states, '_id');
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        StaticData.getItemsByKey("social_statuses").then(function (socialStatuses) {
            $scope.socialStatuses = [{name: "სოციალური სტატუსი"}].concat(socialStatuses);
            $scope.socialStatusesMap = _.keyBy($scope.socialStatuses, '_id');
        });

        StaticData.getItemsByKey("military_state").then(function (militaryStates) {
            $scope.militaryStates = [{name: "სამხედრო ვალდებულება"}].concat(militaryStates);
            $scope.militaryStatesMap = _.keyBy($scope.militaryStates, '_id');
        });

        StaticData.getItemsByKey("info_source").then(function (infoSources) {
            $scope.infoSources = [{name: "საიდან გაიგეთ უნივერსიტეტის შესახებ"}].concat(infoSources);
            $scope.infoSourcesMap = _.keyBy($scope.infoSources, '_id');
        });

        StaticData.getItemsByKey("teacher_program_subjects").then(function (subjects) {
            $scope.subjects = [{name: "საგანი"}].concat(subjects);
        });

        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            clearText: "წაშლა",
            closeText: "დახურვა",
            currentText: "დღეს",
        };

        $scope.changeLevel = function () {
            $scope.subject = null;
            $scope.showSubjectField = $scope.level==='level04';
        }

        $scope.create = function () {
            if (!$scope.chosenUser || !$scope.chosenUser._id) {
                toastr.error('', 'გთხოვთ მიუთითოთ მომხმარებელი');
            } else if (!$scope.state) {
                toastr.error('', 'გთხოვთ მიუთითოთ სტატუსი');
            } else if (!$scope.level) {
                toastr.error('', 'გთხოვთ მიუთითოთ საფეხური');
            } else if ($scope.semester == 'სემესტრი') {
                toastr.error('', 'გთხოვთ მიუთითოთ სემესტრი');
            } else if (!$scope.faculty) {
                toastr.error('', 'გთხოვთ მიუთითოთ ფაკულტეტი');
            } else if (!$scope.chosenProgram) {
                toastr.error('', 'გთხოვთ მიუთითოთ პროგრამა');
            } else {
                var student = {};
                student.info = {};
                student.user = $scope.chosenUser._id;
                student.state = $scope.state;
                student.program = $scope.chosenProgram._id;
                student.info.faculty = $scope.faculty;
                student.info.level = $scope.level;
                student.info.semester = Number.parseInt($scope.semester);
                student.info.choiceNumber = $scope.choiceNumber;
                student.info.school = $scope.school;
                student.info.graduationYear = $scope.graduationYear;
                student.info.certificateNumber = $scope.certificateNumber;
                student.info.certificateSeries = $scope.certificateSeries;
                student.info.certificateDate = $scope.certificateDate;
                student.info.certificateFile = $scope.certificateFile;
                student.info.certificateFileName = $scope.fileNameCert;
                student.info.workPlace = $scope.workPlace;
                student.info.workPosition = $scope.workPosition;
                student.info.socialStatus = $scope.socialStatus;
                student.info.militaryState = $scope.militaryState;
                student.info.militaryDoc = $scope.militaryDoc;
                student.info.militaryDocFileName = $scope.fileName;
                student.info.achievement = $scope.achievement;
                student.info.infoSource = $scope.infoSource;
                if($scope.subject) {
                    student.info.subject = $scope.subject;
                }

                Students.add(student).then(function () {
                    $uibModalInstance.close();
                }).catch(function (err) {
                    if (err.status == 400) {
                        toastr.error('', 'მიმდინარე სტუდენს უკვე აქვს სტუდენტის აქტიური პროფილი.');
                    } else {
                        toastr.error('', 'დაფიქსირდა შეცდომა');
                    }
                });
            }
        };

        $scope.uploadImage = function (files, field) {
            $scope.file = files[0];
            if (_.includes(field, 'certificate')) $scope.fileNameCert = $scope.file.name;
            else $scope.fileName = $scope.file.name;
            var fd = new FormData();
            fd.append('file', $scope.file);
            fd.append('student', $scope.student._id);
            $http.post('/file/' + field + '/add', fd, {
                headers: {'Content-Type': undefined}
            }).then(function (response) {
                if (field === 'info.militaryDoc') {
                    $scope.militaryDoc = response.data.path;
                } else if (field === 'info.certificate.file') {
                    $scope.certificateFile = response.data.path;
                }
            })
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
